import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys);

export const Tabs = defineMultiStyleConfig({
  variants: {
    "soft-rounded": definePartsStyle(() => ({
      tab: {
        borderRadius: "full",
        color: "brand.500",
        background: "white",
        fontWeight: 600,
        _selected: {
          background: "brand.200",
          fontWeight: 800,
        },
      },
      tabpanel: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    })),
    line: definePartsStyle(() => ({
      tablist: {
        borderBottom: "0",
      },
    })),
    code: definePartsStyle(() => ({
      tablist: {
        backgroundColor: "#1D1F21",
        borderTopRadius: "12px",
        borderBottom: "1px solid",
        borderBottomColor: "#26282A",
      },
      tabpanels: {
        backgroundColor: "#1D1F21",
        borderBottomRadius: "12px",
        padding: 0,
      },
      tab: {
        textTransform: "uppercase",
        color: "gray.400",
        fontFamily: "var(--ibm-plex-mono)",
        fontWeight: 500,
        fontSize: "12px",
        padding: "8px 16px",
        borderRight: "1px solid",
        borderBottom: "1px solid",
        borderColor: "#26282A",
        marginBottom: "-1px",
        _selected: {
          color: "white",
          borderBottomColor: "#1D1F21",
        },
      },
    })),
  },
  defaultProps: {
    size: "sm",
    colorScheme: "brand",
    variant: "soft-rounded",
  },
});
